// Utility: get display name for visual style in current language
export function getVisualStyleDisplayName(styleKey, lang = 'en') {
  const style = visualStylesData.find(s => s.key === styleKey);
  if (!style) return styleKey;
  return style[lang] || style.en || style.key;
}

// Utility: get style key from display name (for select value to backend)
export function getVisualStyleKeyFromDisplayName(displayName, lang = 'en') {
  const style = visualStylesData.find(s => s[lang] === displayName);
  return style ? style.key : displayName;
}

export const environmentsData = [
  "School",
  "Home",
  "Playground",
  "Library",
  "Supermarket",
  "Park",
  "Restaurant",
  "Clinic"
];

export const visualStylesData = [
  {
    key: "East Asian",
    en: "East Asian",
    fr: "Asiatique de l'Est",
    "zh-TW": "東亞風格",
    "zh-CN": "东亚风格"
  },
  {
    key: "Southeast Asian",
    en: "Southeast Asian",
    fr: "Asiatique du Sud-Est",
    "zh-TW": "東南亞風格",
    "zh-CN": "东南亚风格"
  },
  {
    key: "South Asian",
    en: "South Asian",
    fr: "Asiatique du Sud",
    "zh-TW": "南亞風格",
    "zh-CN": "南亚风格"
  },
  {
    key: "Middle Eastern / West Asian",
    en: "Middle Eastern / West Asian",
    fr: "Moyen-Orient / Asie de l'Ouest",
    "zh-TW": "中東/西亞風格",
    "zh-CN": "中东/西亚风格"
  },
  {
    key: "Western / European",
    en: "Western / European",
    fr: "Occidental / Européen",
    "zh-TW": "西方/歐洲風格",
    "zh-CN": "西方/欧洲风格"
  },
  {
    key: "African / Afro-diaspora",
    en: "African / Afro-diaspora",
    fr: "Africain / Afro-diaspora",
    "zh-TW": "非洲/非洲散居風格",
    "zh-CN": "非洲/非洲侨民风格"
  },
  {
    key: "Latin American",
    en: "Latin American",
    fr: "Latino-américain",
    "zh-TW": "拉丁美洲風格",
    "zh-CN": "拉丁美洲风格"
  }
];

export const cognitiveLevelsData = [
  { Name: "Intermediate", Label: "Intermediate" },
  { Name: "Basic", Label: "Basic" },
  { Name: "Advanced", Label: "Advanced" }
];

// Story language options used in UI dropdowns
export const STORY_LANGUAGES = [
  { value: 'English', label: 'English' },
  { value: 'French', label: 'Français' },
  { value: 'Simplified Chinese', label: '简体中文' },
  { value: 'Traditional Chinese', label: '繁體中文' },
];

export const socialSkillsData = {
  Greetings_Communication: [
    { key: "Saying hello", en: "Saying hello", fr: "Dire bonjour", "zh-TW": "打招呼", "zh-CN": "打招呼" },
    { key: "Saying goodbye", en: "Saying goodbye", fr: "Dire au revoir", "zh-TW": "說再見", "zh-CN": "说再见" },
    { key: "Introducing self", en: "Introducing self", fr: "Se présenter", "zh-TW": "自我介紹", "zh-CN": "自我介绍" },
    { key: "Asking for help", en: "Asking for help", fr: "Demander de l'aide", "zh-TW": "請求幫助", "zh-CN": "请求帮助" },
    { key: "Making a request", en: "Making a request", fr: "Faire une demande", "zh-TW": "提出請求", "zh-CN": "提出请求" },
    { key: "Saying thank you", en: "Saying thank you", fr: "Dire merci", "zh-TW": "說謝謝", "zh-CN": "说谢谢" },
    { key: "Giving a compliment", en: "Giving a compliment", fr: "Faire un compliment", "zh-TW": "給予讚美", "zh-CN": "给予赞美" },
    { key: "Answering questions", en: "Answering questions", fr: "Répondre aux questions", "zh-TW": "回答問題", "zh-CN": "回答问题" },
    { key: "Starting a conversation", en: "Starting a conversation", fr: "Commencer une conversation", "zh-TW": "開始對話", "zh-CN": "开始对话" },
    { key: "Ending a conversation politely", en: "Ending a conversation politely", fr: "Terminer une conversation poliment", "zh-TW": "有禮貌地結束對話", "zh-CN": "有礼貌地结束对话" }
  ],
  Play_PeerInteraction: [
    { key: "Taking turns", en: "Taking turns", fr: "Prendre son tour", "zh-TW": "輪流", "zh-CN": "轮流" },
    { key: "Sharing toys or materials", en: "Sharing toys or materials", fr: "Partager des jouets ou du matériel", "zh-TW": "分享玩具或物品", "zh-CN": "分享玩具或物品" },
    { key: "Waiting patiently", en: "Waiting patiently", fr: "Attendre patiemment", "zh-TW": "耐心等待", "zh-CN": "耐心等待" },
    { key: "Joining a group activity", en: "Joining a group activity", fr: "Rejoindre une activité de groupe", "zh-TW": "參加團體活動", "zh-CN": "参加团体活动" },
    { key: "Playing by the rules", en: "Playing by the rules", fr: "Jouer selon les règles", "zh-TW": "遵守規則", "zh-CN": "遵守规则" },
    { key: "Inviting a peer to play", en: "Inviting a peer to play", fr: "Inviter un camarade à jouer", "zh-TW": "邀請同伴玩耍", "zh-CN": "邀请同伴玩耍" },
    { key: "Accepting winning and losing", en: "Accepting winning and losing", fr: "Accepter de gagner ou perdre", "zh-TW": "接受輸贏", "zh-CN": "接受输赢" },
    { key: "Including others in play", en: "Including others in play", fr: "Inclure les autres dans le jeu", "zh-TW": "讓他人參與遊戲", "zh-CN": "让他人参与游戏" },
    { key: "Responding when others say no", en: "Responding when others say no", fr: "Réagir quand on dit non", "zh-TW": "他人拒絕時的回應", "zh-CN": "他人拒绝时的回应" }
  ],
  EmotionalSkills: [
    { key: "Identifying feelings", en: "Identifying feelings", fr: "Identifier les sentiments", "zh-TW": "辨認情緒", "zh-CN": "辨认情绪" },
    { key: "Expressing feelings appropriately", en: "Expressing feelings appropriately", fr: "Exprimer ses sentiments de façon appropriée", "zh-TW": "適當表達情緒", "zh-CN": "适当表达情绪" },
    { key: "Coping with frustration", en: "Coping with frustration", fr: "Gérer la frustration", "zh-TW": "應對挫折", "zh-CN": "应对挫折" },
    { key: "Asking for a break", en: "Asking for a break", fr: "Demander une pause", "zh-TW": "請求休息", "zh-CN": "请求休息" },
    { key: "Using calming strategies", en: "Using calming strategies", fr: "Utiliser des stratégies d'apaisement", "zh-TW": "使用冷靜策略", "zh-CN": "使用冷静策略" },
    { key: "Accepting changes in routine", en: "Accepting changes in routine", fr: "Accepter les changements de routine", "zh-TW": "接受日常變化", "zh-CN": "接受日常变化" },
    { key: "Handling disappointment", en: "Handling disappointment", fr: "Gérer la déception", "zh-TW": "處理失望", "zh-CN": "处理失望" },
    { key: "Dealing with teasing or bullying", en: "Dealing with teasing or bullying", fr: "Faire face aux moqueries ou à l'intimidation", "zh-TW": "應對嘲笑或霸凌", "zh-CN": "应对嘲笑或霸凌" }
  ],
  Classroom_SchoolSkills: [
    { key: "Raising hand to speak", en: "Raising hand to speak", fr: "Lever la main pour parler", "zh-TW": "舉手發言", "zh-CN": "举手发言" },
    { key: "Following directions", en: "Following directions", fr: "Suivre les instructions", "zh-TW": "遵從指示", "zh-CN": "遵从指示" },
    { key: "Lining up", en: "Lining up", fr: "Faire la queue", "zh-TW": "排隊", "zh-CN": "排队" },
    { key: "Waiting for teacher’s attention", en: "Waiting for teacher’s attention", fr: "Attendre l'attention de l'enseignant", "zh-TW": "等待老師注意", "zh-CN": "等待老师注意" },
    { key: "Completing work before play", en: "Completing work before play", fr: "Finir le travail avant de jouer", "zh-TW": "先完成作業再玩耍", "zh-CN": "先完成作业再玩耍" },
    { key: "Listening quietly during lessons", en: "Listening quietly during lessons", fr: "Écouter en silence pendant les leçons", "zh-TW": "上課時安靜聆聽", "zh-CN": "上课时安静聆听" },
    { key: "Working with a partner or group", en: "Working with a partner or group", fr: "Travailler avec un partenaire ou un groupe", "zh-TW": "與夥伴或團體合作", "zh-CN": "与伙伴或团体合作" },
    { key: "Transitioning between activities", en: "Transitioning between activities", fr: "Passer d'une activité à l'autre", "zh-TW": "活動間的轉換", "zh-CN": "活动间的转换" }
  ],
  SelfCare_Independence: [
    { key: "Washing hands", en: "Washing hands", fr: "Se laver les mains", "zh-TW": "洗手", "zh-CN": "洗手" },
    { key: "Brushing teeth", en: "Brushing teeth", fr: "Se brosser les dents", "zh-TW": "刷牙", "zh-CN": "刷牙" },
    { key: "Using the bathroom appropriately", en: "Using the bathroom appropriately", fr: "Utiliser correctement les toilettes", "zh-TW": "正確如廁", "zh-CN": "正确如厕" },
    { key: "Getting dressed for outdoor play", en: "Getting dressed for outdoor play", fr: "S'habiller pour jouer dehors", "zh-TW": "穿好衣服去戶外玩耍", "zh-CN": "穿好衣服去户外玩耍" },
    { key: "Eating lunch politely", en: "Eating lunch politely", fr: "Manger poliment à midi", "zh-TW": "有禮貌地吃午餐", "zh-CN": "有礼貌地吃午餐" },
    { key: "Cleaning up after self", en: "Cleaning up after self", fr: "Ranger après soi", "zh-TW": "自己收拾", "zh-CN": "自己收拾" },
    { key: "Using personal space", en: "Using personal space", fr: "Respecter l'espace personnel", "zh-TW": "使用個人空間", "zh-CN": "使用个人空间" }
  ],
  Community_Safety: [
    { key: "Crossing the street safely", en: "Crossing the street safely", fr: "Traverser la rue en toute sécurité", "zh-TW": "安全過馬路", "zh-CN": "安全过马路" },
    { key: "Staying with an adult in public", en: "Staying with an adult in public", fr: "Rester avec un adulte en public", "zh-TW": "在公共場合與大人同行", "zh-CN": "在公共场合与大人同行" },
    { key: "Asking store staff for help", en: "Asking store staff for help", fr: "Demander de l'aide au personnel du magasin", "zh-TW": "向店員求助", "zh-CN": "向店员求助" },
    { key: "Using polite words in public", en: "Using polite words in public", fr: "Utiliser des mots polis en public", "zh-TW": "在公共場合使用禮貌用語", "zh-CN": "在公共场合使用礼貌用语" },
    { key: "Wearing seatbelt on bus or car", en: "Wearing seatbelt on bus or car", fr: "Mettre la ceinture dans le bus ou la voiture", "zh-TW": "在公車或汽車上繫安全帶", "zh-CN": "在公交或汽车上系安全带" },
    { key: "Following playground rules", en: "Following playground rules", fr: "Suivre les règles du terrain de jeu", "zh-TW": "遵守遊樂場規則", "zh-CN": "遵守游乐场规则" },
    { key: "Fire drill or emergency routine", en: "Fire drill or emergency routine", fr: "Exercice d'incendie ou routine d'urgence", "zh-TW": "消防演習或緊急程序", "zh-CN": "消防演习或紧急程序" },
    { key: "Stranger safety awareness", en: "Stranger safety awareness", fr: "Sensibilisation à la sécurité face aux inconnus", "zh-TW": "陌生人安全意識", "zh-CN": "陌生人安全意识" }
  ],
  Perspective_SocialAwareness: [
    { key: "Understanding that others have feelings", en: "Understanding that others have feelings", fr: "Comprendre que les autres ont des sentiments", "zh-TW": "理解他人有情感", "zh-CN": "理解他人有情感" },
    { key: "Respecting personal space", en: "Respecting personal space", fr: "Respecter l'espace personnel", "zh-TW": "尊重個人空間", "zh-CN": "尊重个人空间" },
    { key: "Not interrupting", en: "Not interrupting", fr: "Ne pas interrompre", "zh-TW": "不打斷他人", "zh-CN": "不打断他人" },
    { key: "Listening when others talk", en: "Listening when others talk", fr: "Écouter quand les autres parlent", "zh-TW": "他人說話時要聆聽", "zh-CN": "他人说话时要聆听" },
    { key: "Accepting differences", en: "Accepting differences", fr: "Accepter les différences", "zh-TW": "接受差異", "zh-CN": "接受差异" },
    { key: "Saying sorry or apologizing", en: "Saying sorry or apologizing", fr: "Dire pardon ou s'excuser", "zh-TW": "道歉或說對不起", "zh-CN": "道歉或说对不起" },
    { key: "Recognizing when someone needs help", en: "Recognizing when someone needs help", fr: "Reconnaître quand quelqu'un a besoin d'aide", "zh-TW": "察覺他人需要幫助時", "zh-CN": "察觉他人需要帮助时" }
  ]
};

const scheduleItems = (items) => items.map(([en, fr, zhTW, zhCN]) => ({
  key: en,
  en,
  fr,
  "zh-TW": zhTW,
  "zh-CN": zhCN
}));

export const scheduleCategoriesData = {
  Daily_Living: scheduleItems([
    ["Morning routine", "Routine du matin", "早晨流程", "早晨流程"],
    ["Getting dressed", "S'habiller", "穿衣服", "穿衣服"],
    ["Bathroom routine", "Routine des toilettes", "如廁流程", "如厕流程"],
    ["Brushing teeth", "Se brosser les dents", "刷牙", "刷牙"],
    ["Washing hands", "Se laver les mains", "洗手", "洗手"],
    ["Hair brushing", "Se brosser les cheveux", "梳頭髮", "梳头发"],
    ["Shower/Bath", "Douche/Bain", "淋浴／洗澡", "淋浴／洗澡"],
    ["Bedtime routine", "Routine du coucher", "睡前流程", "睡前流程"]
  ]),
  School: scheduleItems([
    ["Get ready for school", "Se préparer pour l'école", "準備上學", "准备上学"],
    ["Backpack routine", "Routine du sac à dos", "書包整理流程", "书包整理流程"],
    ["Classroom work", "Travail en classe", "課堂作業", "课堂作业"],
    ["Circle time at school", "Temps de rassemblement à l'école", "學校團體時間", "学校集体活动时间"],
    ["School Reading time", "Temps de lecture à l'école", "學校閱讀時間", "学校阅读时间"],
    ["Art class", "Cours d'arts plastiques", "美術課", "美术课"],
    ["Music class", "Cours de musique", "音樂課", "音乐课"],
    ["Eating Lunch at school", "Déjeuner à l'école", "在学校吃午餐", "在学校吃午餐"],
    ["School Recess", "Récréation à l'école", "學校下課休息", "学校课间休息"],
    ["School Gym class", "Cours d'éducation physique", "體育課", "体育课"],
    ["End of school", "Fin de la journée scolaire", "放學", "放学"],
    ["Homework", "Devoirs", "家庭作業", "家庭作业"]
  ]),
  Home: scheduleItems([
    ["Cleaning bedroom", "Ranger la chambre", "整理房間", "整理房间"],
    ["Making the bed", "Faire le lit", "整理床鋪", "整理床铺"],
    ["Laundry", "Faire la lessive", "洗衣服", "洗衣服"],
    ["Setting the table", "Mettre la table", "擺餐桌", "摆餐桌"],
    ["Helping cook", "Aider à cuisiner", "幫忙做飯", "帮忙做饭"],
    ["Feeding pets", "Nourrir les animaux", "餵寵物", "喂宠物"],
    ["Taking out garbage", "Sortir les poubelles", "倒垃圾", "倒垃圾"],
    ["Family chores", "Tâches ménagères familiales", "家庭雜務", "家庭杂务"]
  ]),
  Eating: scheduleItems([
    ["Make breakfast", "Préparer le petit-déjeuner", "做早餐", "做早餐"],
    ["Prepare snack", "Préparer une collation", "準備點心", "准备点心"],
    ["Lunch routine", "Routine du déjeuner", "午餐流程", "午餐流程"],
    ["Dinner routine", "Routine du dîner", "晚餐流程", "晚餐流程"],
    ["Restaurant routine", "Routine au restaurant", "餐廳用餐流程", "餐厅用餐流程"],
    ["Picnic", "Pique-nique", "野餐", "野餐"]
  ]),
  Community: scheduleItems([
    ["Grocery shopping", "Faire les courses", "採買日用品", "购买日用品"],
    ["Library", "Bibliothèque", "圖書館", "图书馆"],
    ["Playground", "Terrain de jeux", "遊樂場", "游乐场"],
    ["Swimming pool", "Piscine", "游泳池", "游泳池"],
    ["Haircut", "Coupe de cheveux", "理髮", "理发"],
    ["Pharmacy", "Pharmacie", "藥房", "药房"],
    ["Bank", "Banque", "銀行", "银行"],
    ["Post office", "Bureau de poste", "郵局", "邮局"],
    ["Museum", "Musée", "博物館", "博物馆"],
    ["Zoo", "Zoo", "動物園", "动物园"]
  ]),
  Appointments: scheduleItems([
    ["Doctor", "Médecin", "看醫生", "看医生"],
    ["Dentist", "Dentiste", "看牙醫", "看牙医"],
    ["Music lesson", "Cours de musique", "音樂課程", "音乐课程"]
  ]),
  Activities: scheduleItems([
    ["Arts & crafts", "Arts et bricolage", "美術與手作", "美术与手工"],
    ["Lego", "Lego", "樂高積木", "乐高积木"],
    ["Reading", "Lecture", "閱讀", "阅读"],
    ["Baking", "Pâtisserie", "烘焙", "烘焙"],
    ["Gardening", "Jardinage", "園藝", "园艺"],
    ["Bike riding", "Faire du vélo", "騎自行車", "骑自行车"],
    ["Swimming", "Natation", "游泳", "游泳"],
    ["Soccer", "Football", "足球", "足球"],
    ["Dance", "Danse", "跳舞", "跳舞"]
  ]),
  Travel: scheduleItems([
    ["Car ride", "Trajet en voiture", "乘坐汽車", "乘坐汽车"],
    ["School bus", "Autobus scolaire", "校車", "校车"],
    ["Public transit", "Transports en commun", "大眾運輸", "公共交通"],
    ["Airport", "Aéroport", "機場", "机场"],
    ["Hotel", "Hôtel", "飯店", "酒店"],
    ["Camping", "Camping", "露營", "露营"]
  ]),
  Holidays_Special_Events: scheduleItems([
    ["Birthday party", "Fête d'anniversaire", "生日派對", "生日派对"],
    ["Family gathering", "Réunion de famille", "家庭聚會", "家庭聚会"],
    ["Wedding", "Mariage", "婚禮", "婚礼"],
    ["Halloween", "Halloween", "萬聖節", "万圣节"],
    ["Christmas", "Noël", "聖誕節", "圣诞节"],
    ["Easter", "Pâques", "復活節", "复活节"],
    ["Lunar New Year", "Nouvel An lunaire", "農曆新年", "农历新年"]
  ]),
  Self_Regulation: scheduleItems([
    ["Calm down", "Se calmer", "冷靜下來", "冷静下来"],
    ["Deep breathing", "Respiration profonde", "深呼吸", "深呼吸"],
    ["Sensory break", "Pause sensorielle", "感官休息", "感官休息"],
    ["Ask for help", "Demander de l'aide", "尋求幫助", "寻求帮助"],
    ["Break card routine", "Routine de la carte de pause", "休息卡使用流程", "休息卡使用流程"],
    ["Quiet corner", "Coin calme", "安靜角落", "安静角落"]
  ]),
  Safety: scheduleItems([
    ["Fire drill", "Exercice d'incendie", "消防演習", "消防演习"],
    ["Earthquake drill", "Exercice de tremblement de terre", "地震演習", "地震演习"],
    ["Crossing the street", "Traverser la rue", "過馬路", "过马路"],
    ["Calling 911", "Appeler le 911", "撥打 911", "拨打 911"],
    ["Stranger safety", "Sécurité face aux inconnus", "陌生人安全", "陌生人安全"]
  ])
};

// Utility: get display name for social skill in current language
export function getSocialSkillDisplayName(skillKey, category, lang = 'en') {
  const arr = socialSkillsData[category] || [];
  const skill = arr.find(s => s.key === skillKey);
  if (!skill) return skillKey;
  return skill[lang] || skill.en || skill.key;
}


// Utility: get skill key from display name (for select value to backend)
export function getSocialSkillKeyFromDisplayName(displayName, category, lang = 'en') {
  const arr = socialSkillsData[category] || [];
  const skill = arr.find(s => s[lang] === displayName);
  return skill ? skill.key : displayName;
}

export const voicesData = [
  {
    key: "male",
    en: "male",
    fr: "masculin",
    "zh-TW": "男聲",
    "zh-CN": "男声"
  },
  {
    key: "female",  
    en: "female",
    fr: "féminin",
    "zh-TW": "女聲",
    "zh-CN": "女声"
  }
  // ,
  // {
  //   key: "personalized",
  //   en: "personalized",
  //   fr: "personnalisé",
  //   "zh-TW": "個人化",
  //   "zh-CN": "个性化"
  // }
];  

// Utility: get display name for voices in current language
export function getVoiceDisplayName(voiceKey, lang = 'en') {
  const voice = voicesData.find(s => s.key === voiceKey);
  if (!voice) return voiceKey;
  return voice[lang] || voice.en || voice.key;
}

// Utility: get voice key from display name (for select value to backend)
export function getVoiceKeyFromDisplayName(displayName, lang = 'en') {
  const voice = voicesData.find(s => s[lang] === displayName);
  return voice ? voice.key : displayName;
}
